import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { InputLabel, Tooltip, FormControl } from '@mui/material';

import { Dialog } from '../../../../common/components/Dialog/Dialog';
import Button from '../../../../common/components/Button/Button';
import { CHARGER_TASK_TYPE_VALUE_LABEL_MAP } from '../../../../common/constants/chargerTask';
import { FormColumn, FormValueDisplay, FormValueDisplayGroup, FormWrap } from '../../../../common/components/ChargerTaskForm/style';
import FormSectionSeparator from '../../../../common/components/FormSectionSeparator/FormSectionSeparator';
import { substr } from '../../../../common/components/ChargerTaskForm/DiagnosticCategoriesControl';

const Title = styled.div`
  display: flex;
  align-items: center;

  .MuiSvgIcon-root {
    margin-left: 10px;
  }
`;

function ChargerTaskDetailsDialog(props) {
  const { isOpen, close, task } = props;

  const actions = [
    <Button key="cancel-btn" onClick={close}>
      Cancel
    </Button>,
  ];

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      actions={actions}
      title={
        <Title>
          {`${CHARGER_TASK_TYPE_VALUE_LABEL_MAP[task.type]} - Details`}
          {/*
            task.enableNotifications && (
              <Tooltip title="Notification about completion has been turned on">
                <NotificationsActiveIcon />
              </Tooltip>
            )
            */}
        </Title>
      }
      open={isOpen}
      modal
      onClose={close}
    >
      <FormWrap>
        <FormColumn>
          <FormControl>
            <InputLabel shrink>Logs time (UTC) from</InputLabel>
            <FormValueDisplay>{moment(task.collectFromTimestamp, 'X').format('MMMM D, YYYY hh:mm A')}</FormValueDisplay>
          </FormControl>
        </FormColumn>
        <FormColumn>
          <FormControl>
            <InputLabel shrink>Logs time (UTC) to</InputLabel>
            <FormValueDisplay>{moment(task.collectToTimestamp, 'X').format('MMMM D, YYYY hh:mm A')}</FormValueDisplay>
          </FormControl>
        </FormColumn>
        {task.note && (
          <FormColumn className="full-width">
            <FormControl>
              <InputLabel shrink>Notes</InputLabel>
              <FormValueDisplay>{task.note}</FormValueDisplay>
            </FormControl>
          </FormColumn>
        )}
        <FormSectionSeparator>
          Used
          {task.simple ? 'simple' : 'extended'} mode
        </FormSectionSeparator>
        <FormColumn>
          {task.pcapFiles && (
            <FormControl fullWidth>
              <InputLabel shrink>Not related to Time Range</InputLabel>
              <FormValueDisplay>Pcap files</FormValueDisplay>
            </FormControl>
          )}
          <FormControl>
            <InputLabel shrink>Diagnostic categories</InputLabel>
            <FormValueDisplayGroup>
              {task.diagnostics.map((item) => (
                <FormValueDisplay key={item.category}>
                  {item.category.length > 22 && (
                    <Tooltip title={item.category}>
                      <span>{substr(item.category, 22)}</span>
                    </Tooltip>
                  )}
                  {item.category.length <= 22 && <span>{item.category}</span>}

                  <span className="secondary">{item.parameter}</span>
                </FormValueDisplay>
              ))}
            </FormValueDisplayGroup>
          </FormControl>
        </FormColumn>

        <FormColumn>
          {(task.systemInfo || task.configs) && (
            <FormControl fullWidth>
              <InputLabel shrink>Included</InputLabel>
              <FormValueDisplayGroup>
                {task.configs && <FormValueDisplay>Configs</FormValueDisplay>}
                {task.systemInfo && <FormValueDisplay>System info</FormValueDisplay>}
              </FormValueDisplayGroup>
            </FormControl>
          )}

          {task.autoUpload && (
            <FormControl fullWidth>
              <InputLabel shrink>Upload to cloud</InputLabel>
              <FormValueDisplay>Automatically</FormValueDisplay>
            </FormControl>
          )}

          {task.autoUpload && (
            <FormControl fullWidth>
              <InputLabel shrink>Max file size</InputLabel>
              <FormValueDisplay>{task.autoUploadSizeLimit} Mb</FormValueDisplay>
            </FormControl>
          )}
        </FormColumn>
      </FormWrap>
    </Dialog>
  );
}

export default ChargerTaskDetailsDialog;
